import React from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import DeleteIcon from "@mui/icons-material/Delete";

import { certificateData } from "../../../../../../data/data";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@mui/material";
const CertificatesTable = ({ openClick, data: rows }) => {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow
              sx={{
                "& .MuiTableCell-root": {
                  fontWeight: 700,
                },
              }}
            >
              <TableCell>Certificate</TableCell>
              <TableCell>Key</TableCell>
              <TableCell>Issuer</TableCell>
              <TableCell>Validity</TableCell>

              {/* <TableCell></TableCell> */}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows && rows.length > 0 ? (
              rows
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row) => (
                  <TableRow key={row.name} sx={{ backgroundColor: "#fff" }}>
                    <TableCell>{row.name}</TableCell>
                    <TableCell>{row.key}</TableCell>
                    <TableCell>{row.issuer}</TableCell>
                    <TableCell>{row.validity}</TableCell>

                    {/* <TableCell>
                    <DeleteIcon
                      sx={{
                        width: "1.5rem",
                        color: "rgba(0,0,0,0.65)",
                        "&:hover": {
                          cursor: "pointer",
                          //backgroundColor: "var(--main-grey)",
                          color: "rgba(0,0,0,0.95)",
                        },
                      }}
                      onClick={() => openClick()}
                    />
                  </TableCell> */}
                  </TableRow>
                ))
            ) : (
              <TableRow sx={{ backgroundColor: "#transparent" }}>
                <TableCell colSpan={4} align="center">
                  No certificates created
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {rows && rows.length > 5 && (
        <TablePagination
          sx={{
            "& .MuiTablePagination-selectLabel": { display: "none" },
            "& .MuiTablePagination-input": { display: "none" },
          }}
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      )}
    </>
  );
};

export default CertificatesTable;
